<template>
  <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="max-height: 400px" class="scroll-y">
      <v-text-field
        :value="localObject.document_name"
        @input="localObject.document_name = $event"
        v-validate="'required|alpha_num'"
        :error-messages="errors.collect('document_name')"
        data-vv-name="document_name"
        label="Dokumentum neve"
        class="mb-3 pt-0"
      ></v-text-field>
      <v-text-field
        :value="localObject.document_page"
        @input="localObject.document_page = $event"
        v-validate="'required|numeric'"
        :error-messages="errors.collect('document_page')"
        data-vv-name="document_page"
        label="Dokumentum oldal"
        hint="A dokumentumok a megadott szám sorrendjében fognak rendeződni"
        class="mb-3 pt-0"
        persistent-hint
      ></v-text-field>
      <div class="title">Képek</div>
      <v-divider class="my-3"></v-divider>
      <v-layout row wrap align-center justify-center>
        <el-upload
          ref="imgUpload"
          :file-list="fileList"
          list-type="picture"
          :on-remove="handleRemove"
          :on-change="setImages"
          action
          drag
          :auto-upload="false"
        >
          <v-layout slot="trigger" row wrap fill-height align-center justify-center>
            <v-flex xs12>
              <v-icon>image</v-icon>
              <div>
                Drop file here or
                <em>click to upload</em>
              </div>
            </v-flex>
          </v-layout>
        </el-upload>
        <v-flex xs12 v-if="localObject.pages && localObject.pages.length == 0">
          <div class="font-weight-bold text-xs-center my-2">A dokumentumhoz még nem vettek fel képet</div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="isLoading" @click="$emit('onClose')">Mégse</v-btn>
      <v-btn
        v-if="actionType === 'save'"
        @click="saveData();"
        :disabled="getImages.length == 0"
        :loading="isLoading"
      >Mentés</v-btn>
      <v-btn
        v-else-if="actionType === 'update'"
        @click="updateData();"
        :disabled="getImages.length == 0"
        :loading="isLoading"
      >Módosítás</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  documentsCollection,
  documentInfoCollection,
  storage,
  db
} from "../firebaseConfig";
import { Promise, async } from "q";
import Raven from "raven-js";
import _ from "lodash";

export default {
  name: "CountriesDocumentDialog",
  props: {
    title: { type: String },
    text: { type: String },
    actionType: { type: String, required: true },
    selectedObject: { type: Object }
  },
  data() {
    return {
      isLoading: false,
      localObject: {},
      fileList: [],
      uploadFileList: [],
      deleteFileList: [],
      leftOverFileList: []
    };
  },
  computed: {
    getImages() {
      return [...this.leftOverFileList, ...this.uploadFileList];
    }
  },

  methods: {
    setImages(image) {
      this.uploadFileList.push(image);
    },
    handleRemove(file, fileList) {
      if (
        _.find(this.fileList, innerFile => {
          return innerFile.uid == file.uid;
        })
      ) {
        this.deleteFileList.push(file);
      }
      this.uploadFileList = _.filter(this.uploadFileList, uploadFile => {
        return uploadFile.uid != file.uid;
      });

      this.leftOverFileList = _.differenceBy(
        fileList,
        this.uploadFileList,
        "uid"
      );
    },
    async uploadImages() {
      let uploadedFiles = [];
      for (const imgData of this.uploadFileList) {
        // const ext = imgData.raw.name.slice(imgData.raw.name.lastIndexOf("."));
        await storage
          .child(`documents/${imgData.raw.uid}`)
          .put(imgData.raw)
          .then(imgData => {
            return imgData.ref.getDownloadURL();
          })
          .then(imgUrl => {
            uploadedFiles.push({
              uid: imgData.uid,
              url: imgUrl,
              name: imgData.name
            });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve(uploadedFiles);
    },
    async deleteImages() {
      for (const imgData of this.deleteFileList) {
        await storage
          .child(`documents/${imgData.uid}`)
          .delete()
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    async deleteDocuments(batch, documentId) {
      for (const imgData of this.deleteFileList) {
        await documentInfoCollection
          .where("document_id", "==", documentId)
          .where("page_uid", "==", Number(imgData.uid))
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              batch.delete(
                documentInfoCollection.doc(querySnapshot.docs[0].id)
              );
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    saveData() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.isLoading = true;

          var batch = db.batch();

          this.uploadImages()
            .then(uploadImages => {
              batch.set(documentsCollection.doc(), {
                document_name: this.localObject.document_name,
                document_page: this.localObject.document_page,
                country_id: this.$route.params.country,
                pages: [...this.leftOverFileList, ...uploadImages]
              });
              return batch.commit();
            })
            .then(() => {
              this.uploadFileList = [];
              this.$emit("onDataChange", true);
            })
            .catch(err => {
              Raven.captureException(err);
              this.$notify({
                group: "app",
                text: `Hiba a dokumentum mentése közben:  ${err.message}`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    updateData() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.isLoading = true;

          var batch = db.batch();

          this.deleteDocuments(batch, this.$route.query.document)
            .then(() => {
              return this.deleteImages();
            })
            .then(() => {
              this.deleteFileList = [];
              return this.uploadImages();
            })
            .then(uploadImages => {
              batch.set(documentsCollection.doc(this.$route.query.document), {
                document_name: this.localObject.document_name,
                document_page: this.localObject.document_page,
                country_id: this.$route.params.country,
                pages: [...this.leftOverFileList, ...uploadImages]
              });
              return batch.commit();
            })
            .then(() => {
              this.uploadFileList = [];
              this.$emit("onDataChange", true);
            })
            .catch(err => {
              Raven.captureException(err);
              this.$notify({
                group: "app",
                text: `Hiba a dokumentum módosítása közben:  ${err.message}`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    initData() {
      if (!_.isEmpty(this.selectedObject)) {
        this.fileList = [
          ..._.map(this.selectedObject.pages, page => {
            return { url: page.url, uid: page.uid, name: page.name };
          })
        ];
        this.localObject = _.cloneDeep(this.selectedObject);
      }
      this.leftOverFileList = this.fileList;
    }
  },
  created() {
    this.initData();
  }
};
</script>

<style>
.el-upload {
  display: flex;
}
</style>

